import * as Scrivito from "scrivito";
import {
  defaultPageEditingConfigAttributes,
  defaultPropertiesGroups,
  defaultPageInitialContent,
  defaultPageProperties,
} from "objs/_defaultPageEditingConfig";
import {
  metadataEditingConfigAttributes,
  metadataInitialContent,
  metadataPropertiesGroups,
} from "objs/_metadataEditingConfig";

Scrivito.provideEditingConfig("Image", {
  attributes: {
    tags: {
      title: "Tags",
      description: "Make it easier to find this Image by adding some tags.",
    },
    alternativeText: {
      title: "Alternative text",
      description: "Brief description of what the image is about.",
    },
    ...defaultPageEditingConfigAttributes,
    ...metadataEditingConfigAttributes,
  },
  properties: ["blob", "headline", "caption", ...defaultPageProperties],
  propertiesGroups: [
    {
      title: "Advanced",
      properties: ["asimUrl", "pimId"],
    },
    ...defaultPropertiesGroups,
    ...metadataPropertiesGroups,
  ],
  initialContent: {
    ...defaultPageInitialContent,
    ...metadataInitialContent,
  },
});
